<template>
  <v-dialog v-model="displayed" width="1100" scrollable>
    <v-card v-if="displayed">
      <v-toolbar color="#eee" height="48px" flat>
        <v-toolbar-title>
          {{ $t('proforma-invoice.sync-task.live-title') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-alert v-if="isProcessing" type="info" text dense class="mb-4">
          {{ $t('proforma-invoice.sync-task.close-hint') }}
        </v-alert>
        <sync-task-progress
            v-if="taskId"
            :task-id="taskId"
            live
            @task-updated="onTaskUpdated"
            @task-finished="$emit('finished', $event)"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn small @click="close">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SyncTaskProgress from "@pages/ProformaInvoice/elements/SyncTaskProgress.vue"

const FINAL_STATUSES = ['DONE', 'FAILED']

/**
 * La resynchronisation tourne sur un serveur : on peut fermer la fenêtre sans l'arrêter, et la
 * retrouver dans l'historique d'automatisation.
 */
export default {
  name: 'SyncTaskProgressModal',

  components: { SyncTaskProgress },

  data() {
    return {
      displayed: false,
      taskId: null,
      currentStatus: null,
    }
  },

  computed: {
    isProcessing() {
      return this.currentStatus !== null && !FINAL_STATUSES.includes(this.currentStatus)
    },
  },

  watch: {
    displayed(value) {
      if (!value) {
        this.taskId = null
        this.currentStatus = null
      }
    },
  },

  methods: {
    open(taskId) {
      this.taskId = taskId
      this.currentStatus = 'PENDING'
      this.displayed = true
    },

    close() {
      this.displayed = false
    },

    onTaskUpdated(task) {
      this.currentStatus = task?.status || null
    },
  },
}
</script>
